<h1 mat-dialog-title>Prévisualisation notification</h1>
<mat-dialog-content>

    <mat-tab-group (selectedIndexChange)="changeTab($event)" mat-stretch-tabs="false" class="label-tab-minimal">
        <mat-tab label="Email">
        </mat-tab>
        <mat-tab label="Pièce Jointe">
        </mat-tab>
    </mat-tab-group>

    <div class="p-1">
        <div id="ContentFrame"></div>
    </div>


</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Fermer</button>
    <button mat-raised-button color="primary" (click)="download()">
        Télécharger la pièce jointe
    </button>
</mat-dialog-actions>
